import { assetUrl, withBase } from "../utils/sitePaths.js";

export default function CTA() {
  return (
    <section
      className="cta-band"
      style={{ "--cta-image": `url(${assetUrl("/images/category-functional-powder.jpg")})` }}
    >
      <div className="section-inner cta-inner">
        <div>
          <p className="eyebrow">Final CTA</p>
          <h2>Let’s build something interesting.</h2>
          <p>
            Whether you’re sourcing ingredients, exploring freeze-dried applications or building the
            next generation of wellness and food products — we’d love to connect.
          </p>
        </div>
        <div className="button-row">
          <a href={withBase("/contact")} className="button button-primary">
            Request Catalog
          </a>
          <a href={withBase("/contact")} className="button button-outline">
            Connect With Us
          </a>
        </div>
      </div>
    </section>
  );
}
